<template>
  <div id="line">
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.buildData();
    window.onresize = (value) => {
      //每次改变窗口调用一次resize()
      this.myChart.resize();
    };
  },
  methods: {
    //生成柱状图数据
    buildData() {
      var columLabel = [
        "关注用户数",
        "当月新增用户数",
        "活跃用户数(30天内访问)",
      ];
      var colorList = [
        "rgba(253,182,40,1)",
        "rgba(206,253,101,1)",
        "rgba(111,197,255,1)",
      ];
      var columName = [];
      var numArr = [];
      var monthArr = [];
      var activeArr = [];
      var numArr = [];
      var arrData = [];
      this.dataList.map((item) => {
        columName.push(item.town);
        numArr.push(item.num);
        monthArr.push(item.monthNum);
        activeArr.push(item.activeNum);
      });
      arrData.push(numArr);
      arrData.push(monthArr);
      arrData.push(activeArr);

      var columnValue = new Array();
      for (var i = 0; i < columLabel.length; i++) {
        if (typeof columLabel[i] === "undefined") {
          break;
        }
        columnValue.push({
          name: columLabel[i],
          type: "bar",
          data: arrData[i],
          itemStyle: {
            normal: {
              color: colorList[i],
            },
          },
          barWidth: 20, //柱图宽度
        });
      }

      this.init(columLabel, columName, columnValue);
    },
    // 生成图形
    init(columLabel, columName, columnValue) {
      this.myChart = echarts.init(document.getElementById("line"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: columLabel,
          itemGap: 17,
          itemHeight: 12,
          textStyle: {
            color: "#ffffff",
            fontSize: 16,
          },
          x: "260",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: [
          {
            min: 0,
            type: "category",
            data: columName,
            boundaryGap: true, // x轴两边是否留白
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色
                fontSize: 16,
              },
            },
          },
        ],
        // 横向拖动
        dataZoom: [
          {
            type: "slider",
            show: true,
            startValue: 0,
            endValue: 5,
            height: "12",
            bottom: "6%",
            zoomLock: true,
            textStyle: {
              color: "#ffffff",
            },
          },
        ],
        yAxis: [
          {
            min: 0,
            max: function (val) {
              return val.max * 2;
            },
            name: "单位（个）",
            nameTextStyle: {
              color: "#ffffff",
              padding: [0, 0, 10, 0],
              fontSize: 15,
            },
            type: "value",
            // 坐标线
            axisLine: {
              show: true,
            },
            // 坐标刻度线
            axisTick: {
              show: true,
            },
            splitLine: { show: false }, //去除网格线
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色
                  fontSize: 15,
              },
            },
          },
        ],
        series: columnValue,
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
#line {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt_echart/user_line.vue